import { useId, useState } from "react";
import { Switch } from "@material-tailwind/react";
import { Tooltip } from "primereact/tooltip";

const DEFAULT_CIRCLE_PROPS = { className: "peer-checked:border-[#437f55] peer-checked:before:bg-[#437f55]" };
const DEFAULT_LABEL_PROPS = { className: "text-sm font-normal text-inherit" };
const HIDE_FLOWBITE_CHECKMARK = { backgroundImage: "none" };

export const ToggleSwitcher = ({ label, tooltip, className, checked, onChange, style, ...rest }) => {
  const [internalChecked, setInternalChecked] = useState(false);
  const isControlled = checked !== undefined;
  const isChecked = isControlled ? checked : internalChecked;
  const tooltipTargetClass = `toggle-switcher-tooltip-${useId().replace(/:/g, "")}`;

  const handleToggle = (e) => {
    if (!isControlled) setInternalChecked(e.target.checked);
    if (onChange) onChange(e.target.checked);
  };

  return (
    <>
      <Switch
        checked={isChecked}
        circleProps={DEFAULT_CIRCLE_PROPS}
        className={`appearance-none checked:bg-[#437f55] ${className ?? ""}`.trim()}
        color="green"
        label={label}
        labelProps={
          tooltip
            ? { ...DEFAULT_LABEL_PROPS, className: `${DEFAULT_LABEL_PROPS.className} ${tooltipTargetClass}` }
            : DEFAULT_LABEL_PROPS
        }
        style={{ ...HIDE_FLOWBITE_CHECKMARK, ...style }}
        onChange={handleToggle}
        {...rest}
      />
      {tooltip && <Tooltip content={tooltip} position="top" target={`.${tooltipTargetClass}`} />}
    </>
  );
};
